"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unlinkProjectFailed = exports.unlinkProjectSuccess = exports.unLinkProjectRequest = exports.clear = exports.linkProjectFailed = exports.linkProjectSuccess = exports.linkProjectRequest = exports.linkFailed = exports.linkSuccess = exports.linkRequest = void 0;
const ActionTypes = require("../../actionTypes/congrid/link");
function linkRequest(items) {
    return {
        type: ActionTypes.LINK_REQUEST,
        payload: items
    };
}
exports.linkRequest = linkRequest;
function linkSuccess() {
    return {
        type: ActionTypes.LINK_SUCCESS
    };
}
exports.linkSuccess = linkSuccess;
function linkFailed(payload) {
    return {
        type: ActionTypes.LINK_FAILED,
        payload
    };
}
exports.linkFailed = linkFailed;
function linkProjectRequest(projectId, key, congridProjects) {
    return {
        type: ActionTypes.LINK_PROJECT_REQUEST,
        payload: {
            projectId,
            key,
            congridProjects
        }
    };
}
exports.linkProjectRequest = linkProjectRequest;
function linkProjectSuccess() {
    return {
        type: ActionTypes.LINK_PROJECT_SUCCESS
    };
}
exports.linkProjectSuccess = linkProjectSuccess;
function linkProjectFailed(payload) {
    return {
        type: ActionTypes.LINK_PROJECT_FAILED,
        payload
    };
}
exports.linkProjectFailed = linkProjectFailed;
function clear() {
    return {
        type: ActionTypes.CLEAR
    };
}
exports.clear = clear;
function unLinkProjectRequest(projectId, congridProjectIds) {
    return {
        type: ActionTypes.UNLINK_PROJECT_REQUEST,
        payload: {
            projectId,
            congridProjectIds
        }
    };
}
exports.unLinkProjectRequest = unLinkProjectRequest;
function unlinkProjectSuccess() {
    return {
        type: ActionTypes.UNLINK_PROJECT_SUCCESS
    };
}
exports.unlinkProjectSuccess = unlinkProjectSuccess;
function unlinkProjectFailed(payload) {
    return {
        type: ActionTypes.UNLINK_PROJECT_FAILED,
        payload
    };
}
exports.unlinkProjectFailed = unlinkProjectFailed;
//# sourceMappingURL=link.js.map